// MY CHRISTMAS — Intelligent budget control (5 languages). Flat keys.
export const extra12 = {
  pt: {
    "budget.table": "Mesa",
    "shopping.price_ph": "Preço",
    "budget.limit": "Orçamento", "budget.planned_amt": "Planejado", "budget.available2": "Disponível",
    "budget.of": "{p} de {l} planejados",
    "budget.band_warn": "Você está próximo do limite do seu orçamento.",
    "budget.band_over": "{v} acima do orçamento.",
    "budget.adjust": "Ajustar orçamento", "budget.new_budget": "Novo orçamento",
    "budget.save_new": "Salvar novo orçamento", "budget.cancel": "Cancelar",
    "budget.rebalance": "Reequilibrar orçamento",
    "budget.rebalance_desc": "Transfira orçamento entre categorias sem alterar o total.",
    "budget.rebalance_from": "De", "budget.rebalance_to": "Para", "budget.rebalance_amount": "Valor",
    "budget.rebalance_confirm": "Sim, reequilibrar", "budget.rebalance_done": "Orçamento reequilibrado.",
    "budget.rebalance_suggest": "Você possui {v} disponíveis em {from}. Deseja transferir {amount} para {to}?",
    "budget.no": "Não", "budget.consolidated": "Visão consolidada",
    "balert.title": "⚠️ Atenção ao seu orçamento",
    "balert.title_total": "⚠️ Atenção ao orçamento total",
    "balert.title_both": "⚠️ Atenção ao seu planejamento",
    "balert.intro": "Esta escolha ultrapassa o orçamento que você definiu para {cat}.",
    "balert.intro_total": "Esta escolha cabe em {cat}, mas ultrapassa o orçamento total do seu Natal.",
    "balert.intro_both": "Esta escolha ultrapassa dois limites do seu planejamento:",
    "balert.your_budget": "Seu orçamento", "balert.already": "Já planejado",
    "balert.this": "Nova escolha", "balert.new_total": "Novo total",
    "balert.over_by": "Você ficará {v} acima do orçamento.",
    "balert.cat_over": "{cat}: {v} acima do orçamento",
    "balert.total_over": "Natal completo: {v} acima do orçamento",
    "balert.question": "Deseja continuar mesmo assim?",
    "balert.back": "Voltar", "balert.adjust": "Ajustar orçamento", "balert.continue": "Sim, continuar",
  },
  en: {
    "budget.table": "Table",
    "shopping.price_ph": "Price",
    "budget.limit": "Budget", "budget.planned_amt": "Planned", "budget.available2": "Available",
    "budget.of": "{p} of {l} planned",
    "budget.band_warn": "You're close to your budget limit.",
    "budget.band_over": "{v} over budget.",
    "budget.adjust": "Adjust budget", "budget.new_budget": "New budget",
    "budget.save_new": "Save new budget", "budget.cancel": "Cancel",
    "budget.rebalance": "Rebalance budget",
    "budget.rebalance_desc": "Move budget between categories without changing the total.",
    "budget.rebalance_from": "From", "budget.rebalance_to": "To", "budget.rebalance_amount": "Amount",
    "budget.rebalance_confirm": "Yes, rebalance", "budget.rebalance_done": "Budget rebalanced.",
    "budget.rebalance_suggest": "You have {v} available in {from}. Transfer {amount} to {to}?",
    "budget.no": "No", "budget.consolidated": "Consolidated view",
    "balert.title": "⚠️ Heads up on your budget",
    "balert.title_total": "⚠️ Heads up on your total budget",
    "balert.title_both": "⚠️ Heads up on your plan",
    "balert.intro": "This choice goes over the budget you set for {cat}.",
    "balert.intro_total": "This fits in {cat}, but goes over your total Christmas budget.",
    "balert.intro_both": "This choice goes over two limits of your plan:",
    "balert.your_budget": "Your budget", "balert.already": "Already planned",
    "balert.this": "New choice", "balert.new_total": "New total",
    "balert.over_by": "You'll be {v} over budget.",
    "balert.cat_over": "{cat}: {v} over budget",
    "balert.total_over": "Whole Christmas: {v} over budget",
    "balert.question": "Do you want to continue anyway?",
    "balert.back": "Back", "balert.adjust": "Adjust budget", "balert.continue": "Yes, continue",
  },
  es: {
    "budget.table": "Mesa",
    "shopping.price_ph": "Precio",
    "budget.limit": "Presupuesto", "budget.planned_amt": "Planeado", "budget.available2": "Disponible",
    "budget.of": "{p} de {l} planeados",
    "budget.band_warn": "Estás cerca del límite de tu presupuesto.",
    "budget.band_over": "{v} por encima del presupuesto.",
    "budget.adjust": "Ajustar presupuesto", "budget.new_budget": "Nuevo presupuesto",
    "budget.save_new": "Guardar nuevo presupuesto", "budget.cancel": "Cancelar",
    "budget.rebalance": "Reequilibrar presupuesto",
    "budget.rebalance_desc": "Transfiere presupuesto entre categorías sin cambiar el total.",
    "budget.rebalance_from": "De", "budget.rebalance_to": "A", "budget.rebalance_amount": "Importe",
    "budget.rebalance_confirm": "Sí, reequilibrar", "budget.rebalance_done": "Presupuesto reequilibrado.",
    "budget.rebalance_suggest": "Tienes {v} disponibles en {from}. ¿Transferir {amount} a {to}?",
    "budget.no": "No", "budget.consolidated": "Vista consolidada",
    "balert.title": "⚠️ Atención a tu presupuesto",
    "balert.title_total": "⚠️ Atención al presupuesto total",
    "balert.title_both": "⚠️ Atención a tu planificación",
    "balert.intro": "Esta elección supera el presupuesto que definiste para {cat}.",
    "balert.intro_total": "Esto cabe en {cat}, pero supera tu presupuesto total de Navidad.",
    "balert.intro_both": "Esta elección supera dos límites de tu planificación:",
    "balert.your_budget": "Tu presupuesto", "balert.already": "Ya planeado",
    "balert.this": "Nueva elección", "balert.new_total": "Nuevo total",
    "balert.over_by": "Quedarás {v} por encima del presupuesto.",
    "balert.cat_over": "{cat}: {v} por encima",
    "balert.total_over": "Navidad completa: {v} por encima",
    "balert.question": "¿Deseas continuar de todos modos?",
    "balert.back": "Volver", "balert.adjust": "Ajustar presupuesto", "balert.continue": "Sí, continuar",
  },
  fr: {
    "budget.table": "Table",
    "shopping.price_ph": "Prix",
    "budget.limit": "Budget", "budget.planned_amt": "Prévu", "budget.available2": "Disponible",
    "budget.of": "{p} sur {l} prévus",
    "budget.band_warn": "Vous approchez de la limite de votre budget.",
    "budget.band_over": "{v} au-dessus du budget.",
    "budget.adjust": "Ajuster le budget", "budget.new_budget": "Nouveau budget",
    "budget.save_new": "Enregistrer le nouveau budget", "budget.cancel": "Annuler",
    "budget.rebalance": "Rééquilibrer le budget",
    "budget.rebalance_desc": "Transférez du budget entre catégories sans changer le total.",
    "budget.rebalance_from": "De", "budget.rebalance_to": "Vers", "budget.rebalance_amount": "Montant",
    "budget.rebalance_confirm": "Oui, rééquilibrer", "budget.rebalance_done": "Budget rééquilibré.",
    "budget.rebalance_suggest": "Vous avez {v} disponibles dans {from}. Transférer {amount} vers {to} ?",
    "budget.no": "Non", "budget.consolidated": "Vue consolidée",
    "balert.title": "⚠️ Attention à votre budget",
    "balert.title_total": "⚠️ Attention au budget total",
    "balert.title_both": "⚠️ Attention à votre planification",
    "balert.intro": "Ce choix dépasse le budget que vous avez défini pour {cat}.",
    "balert.intro_total": "Cela tient dans {cat}, mais dépasse votre budget total de Noël.",
    "balert.intro_both": "Ce choix dépasse deux limites de votre planification :",
    "balert.your_budget": "Votre budget", "balert.already": "Déjà prévu",
    "balert.this": "Nouveau choix", "balert.new_total": "Nouveau total",
    "balert.over_by": "Vous serez {v} au-dessus du budget.",
    "balert.cat_over": "{cat} : {v} au-dessus",
    "balert.total_over": "Noël complet : {v} au-dessus",
    "balert.question": "Voulez-vous continuer quand même ?",
    "balert.back": "Retour", "balert.adjust": "Ajuster le budget", "balert.continue": "Oui, continuer",
  },
  it: {
    "budget.table": "Tavola",
    "shopping.price_ph": "Prezzo",
    "budget.limit": "Budget", "budget.planned_amt": "Pianificato", "budget.available2": "Disponibile",
    "budget.of": "{p} di {l} pianificati",
    "budget.band_warn": "Sei vicino al limite del tuo budget.",
    "budget.band_over": "{v} oltre il budget.",
    "budget.adjust": "Modifica budget", "budget.new_budget": "Nuovo budget",
    "budget.save_new": "Salva nuovo budget", "budget.cancel": "Annulla",
    "budget.rebalance": "Riequilibra budget",
    "budget.rebalance_desc": "Trasferisci budget tra categorie senza cambiare il totale.",
    "budget.rebalance_from": "Da", "budget.rebalance_to": "A", "budget.rebalance_amount": "Importo",
    "budget.rebalance_confirm": "Sì, riequilibra", "budget.rebalance_done": "Budget riequilibrato.",
    "budget.rebalance_suggest": "Hai {v} disponibili in {from}. Trasferire {amount} a {to}?",
    "budget.no": "No", "budget.consolidated": "Vista consolidata",
    "balert.title": "⚠️ Attenzione al tuo budget",
    "balert.title_total": "⚠️ Attenzione al budget totale",
    "balert.title_both": "⚠️ Attenzione alla tua pianificazione",
    "balert.intro": "Questa scelta supera il budget che hai definito per {cat}.",
    "balert.intro_total": "Rientra in {cat}, ma supera il budget totale del tuo Natale.",
    "balert.intro_both": "Questa scelta supera due limiti della tua pianificazione:",
    "balert.your_budget": "Il tuo budget", "balert.already": "Già pianificato",
    "balert.this": "Nuova scelta", "balert.new_total": "Nuovo totale",
    "balert.over_by": "Sarai {v} oltre il budget.",
    "balert.cat_over": "{cat}: {v} oltre",
    "balert.total_over": "Natale intero: {v} oltre",
    "balert.question": "Vuoi continuare comunque?",
    "balert.back": "Indietro", "balert.adjust": "Modifica budget", "balert.continue": "Sì, continua",
  },
};
